import type { FaireProductEntity } from "../../entity_types/product";

export const p_7gg7rz4w3n: FaireProductEntity = {
  token: "p_7gg7rz4w3n",
  type: "product",
  name: "Shower Steamer & Bath Bomb",
  brandToken: "b_1y0fkwl2",
  brandName: "Roots And Leaves",
  imageUrl:
    "https://cdn.faire.com/fastly/01643405e331f3f7718bca06f0c97e29282b107d64c2f6071280c64641715149.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/254d7174af53fb6aec2f7bb51d439e21f396d5b1bd5cf117ae66090e60dc1d04.png",
    "https://cdn.faire.com/fastly/8d5b6821d67d0fc12197b2558f9e9910295e391490166b212e65d185cb6d7259.png",
    "https://cdn.faire.com/fastly/58860297160fb292a1077dc3f5ce0c5af0562befbe9fe61574449c1350e991a0.png",
    "https://cdn.faire.com/fastly/b51d1850e61d49bc0ce16c9190088808d2738c028d0063b1b1e438629cda193a.png",
    "https://cdn.faire.com/fastly/30948a4c418094460639f02669c77e6321afdcf06f1f3bb17698591b83e24d81.png",
    "https://cdn.faire.com/fastly/d7b021875c7516864a1d87e9e870af20a7d11e1c0a889f37f0fcdd7f3836e994.png",
    "https://cdn.faire.com/fastly/5ede4fd9f7ad3d2a2fa44372996925165cbc209928a4252e1c7bcaff690076a5.png",
    "https://cdn.faire.com/fastly/915bc3b310890183043f5203f7eba205efe0f6dc367c908728228a135ee90f03.png",
    "https://cdn.faire.com/fastly/ff33bfcc99be800413d75a789f2fa14c0e45a65813a874daba20e02ee42720d4.png",
    "https://cdn.faire.com/fastly/2e76de84d2663f84dfa8f2f2bee1adb7d2b24eda73224230b8ff5fd619de3b90.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "Turn any shower into a spa-like experience with our all-natural Shower Steamers. Each steamer is handcrafted with pure therapeutic-grade essential oils, menthol crystals derived from peppermint, and clean ingredients to create an aromatic, feel-good moment in your daily routine. Simply place on a shower shelf and let the steam activate the essential oils—no artificial fragrance, dyes, or fillers.\n\nAvailable in three signature scents:\n• Revive – Energizing peppermint to awaken the senses\n• Lavender – Calming lavender for stress relief and relaxation\n• Eucalyptus – Refreshing eucalyptus to support clear breathing\n\nPackaged in: Compostable kraft box with 4 individually wrapped steamers\n\nDoubles as a bath bomb! Great for self-care gifts, mothers day, christmas, spa boxes, or everyday wellness at an affordable price point for your customers!\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\nBaking Soda, Citric Acid, Menthol Crystals, Witch Hazel, Distilled Water, Organic Essential Oil",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:40.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
